import axios from 'axios';

export function sendCode (params) {
  return axios.post('/api/sendPhoneCode.jspx?phoneNumber='+params);
}

export function submitForm (params) {
  return axios.postForm('/api/saveForm.jspx', params);
}

export function queryCompanyName (params) {
  return axios.postForm('/api/queryCompanyName.jspx', params);
}



// WEBPACK FOOTER //
// ./src/api/form.js